/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export enum FreshserviceIncidentAttribute {
    category = 'category',
    department_id = 'department_id',
    group_id = 'group_id',
    item_category = 'item_category',
    priority = 'priority',
    requester_id = 'requester_id',
    responder_id = 'responder_id',
    source = 'source',
    status = 'status',
    sub_category = 'sub_category',
    workspace_id = 'workspace_id'
}
